import { CustomFlowbiteTheme } from 'flowbite-react';

export const textInputTheme: CustomFlowbiteTheme['textInput'] = {
    field: {
        icon: {
            base: 'pointer-events-auto absolute inset-y-0 left-0 flex items-center pl-3',
            svg: '',
        },
        rightIcon: {
            base: 'pointer-events-auto absolute inset-y-0 right-0 flex items-center pr-3',
            svg: '',
        },
        input: {
            base:
                'block w-full border text-ellipsis' +
                // disabled
                ' disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-catapult-grey-50' +
                ' disabled:helperText-opacity-50 disabled:placeholder-opacity-50',
            sizes: {
                sm: 'p-2 text-sm',
                md: 'p-2.5 text-sm',
                lg: 'text-base p-4',
            },
            colors: {
                /* elements: text | bg | border | placeholder */
                gray:
                    // rest
                    'bg-system-surface-container border-system-outline-variant text-system-on-surface placeholder:text-system-on-surface-variant' +
                    // focus
                    ' focus:border-system-outline focus:ring-0 focus:outline-none focus:text-system-on-surface-variant' +
                    // active
                    ' active:bg-system-on-surface-variant active:text-system-on-surface active:border-system-outline active:ring-0',
                failure:
                    // rest
                    'bg-system-surface-container border-system-error text-system-on-surface placeholder:text-system-on-surface-variant' +
                    // focus
                    ' focus:border-system-error focus:ring-0 focus:text-system-on-surface-variant' +
                    // active
                    ' active:bg-system-on-surface-variant active:text-system-on-surface active:border-system-outline active:ring-0',
            },
        },
    },
};
